import api from '@http/api';

export interface IGetAllFundosTable {
  id: number;
  nome: string;
}

export interface IGetAllFundos {
  error: boolean;
  response?: IGetAllFundosTable[];
}


export interface IRequestFundo {
  nome: string;
}


class Services {
  public async CreateFundo(data: IRequestFundo) {
    return await api
      .post('/api/fundos/Create', data)
      .then(response => {
        return {
          error: false,
          response: response.data,
        };
      })
      .catch(error => {
        return {
          error: true,
          response: [],
        };
      });
  }

}

export default Services;
